<template>
  <div v-loading.fullscreen.lock="fullscreenLoading">
    <el-collapse
      v-if="roles"
      v-model="activeNames"
      style="width: 100%;min-height:100px;"
      v-loading="loading"
      accordion>
      <el-collapse-item
        v-for="r in getData"
        :name="r.name"
        :key="r.name">
        <template slot="title">
          <i :class="`fas fa-${styles[r.name] ? styles[r.name].icon : ''}
          text-${styles[r.name] ? styles[r.name].color : ''}`"></i>&nbsp;{{$t(r.name)}}
        </template>
        <div class="p-20">
          <el-checkbox-group v-model="r.accessibilities">
            <el-checkbox
              v-for="(accessibility, i) in accessibilities"
              :label="accessibility.operation_id"
              :key="`access_${i}`"
              :disabled="role.name !== 'zeus' && r.name === 'owner'"
              @change="handleChange(r, accessibility, $event)">
              <el-tag :type="methodStyles[accessibility.method]">
                {{accessibility.method}}
              </el-tag>
              {{ accessibility.operation_id.replace(/_/g, ' ') }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  data () {
    return {
      loading: true,
      activeNames: [],
      accessibilities: null,
      methods: ['GET', 'POST', 'PATCH', 'PUT', 'DELETE'],
      toPatch: [],
      roleID: null,
      allRoles: null,
      methodStyles: {
        POST: 'success',
        PUT: 'warning',
        PATCH: 'info',
        GET: '',
        DELETE: 'danger'
      },
      styles: {
        owner: {
          icon: 'crown',
          color: 'warning'
        },
        admin: {
          icon: 'briefcase',
          color: 'red'
        },
        user_account_mod: {
          icon: 'briefcase',
          color: 'green'
        },
        regular: {
          icon: 'user',
          color: 'blue'
        },
        guest: {
          icon: 'eye',
          color: 'medium-gray'
        },
        financial_support: {
          icon: 'headphones',
          color: 'violet'
        },
        marketing_manager: {
          icon: 'headphones',
          color: 'primary-light'
        },
        account_manager: {
          icon: 'headphones',
          color: 'green'
        },
        pr_officer: {
          icon: 'headphones',
          color: 'gray-blue-medium'
        },
        support: {
          icon: 'headphones',
          color: 'primary'
        },
        zeus: {
          icon: 'headphones',
          color: 'light-blue'
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'domainsPath',
      'roles',
      'role'
    ]),
    getData () {
      this.setRoles()
      return this.allRoles
    }
  },
  methods: {
    ...mapActions([
      'handleRequest'
    ]),
    toggleLoading () {
      this.loading = !this.loading
    },
    showOperationCanceledMsg (op) {
      this.$message(this.$i18n.t('is_cancelled', {
        operation: this.$i18n.t(op)
      }))
    },
    updateRoleAccessibility () {
      const { toPatch, roleID, domainsPath } = this
      this.toggleLoading()
      this.handleRequest({
        name: `${domainsPath}/roles`,
        action: 'patch',
        data: {
          id: roleID,
          toPatch
        }
      }).finally(this.toggleLoading)
    },
    handleChange (role, accessibility, val) {
      const op = val ? 'add' : 'remove'
      this.toPatch = [{
        op,
        path: 'accessibilities',
        value: {
          endpoint: accessibility.endpoint,
          method: accessibility.method
        }
      }]
      this.roleID = role.id
      this.$confirm(this.$i18n.t('confirm_role_access_update', {
        type: this.$i18n.t(op),
        role: this.$i18n.t(role.name),
        operationID: accessibility.operation_id.replace(/_/g, ' ')
      }), 'Warning', {
        confirmButtonText: this.$i18n.t('ok'),
        cancelButtonText: this.$i18n.t('cancel'),
        showClose: false,
        type: 'warning'
      }).then(this.updateRoleAccessibility)
        .catch(() => {
          this.showOperationCanceledMsg('change_access')
          if (op === 'add') {
            const index = role.accessibilities.indexOf(accessibility.operation_id)
            if (index > -1) {
              role.accessibilities.splice(index, 1)
            }
          } else {
            role.accessibilities.push(accessibility.operation_id)
          }
        })
    },
    setRoles () {
      const { roles } = this
      const found = roles.find(role => role.name === 'owner')
      if (found) {
        this.accessibilities = found.accessibilities
          .reduce((filtered, accessibility) => {
            if (this.methods.indexOf(accessibility.method) > -1) {
              filtered.push(accessibility)
            }
            return filtered
          }, [])
      }
      this.allRoles = roles.map(role => {
        return {
          name: role.name,
          id: role.id.numberStr,
          accessibilities: role.accessibilities
            .reduce((filtered, accessibility) => {
              if (this.methods.indexOf(accessibility.method) > -1) {
                filtered.push(accessibility.operation_id)
              }
              return filtered
            }, [])
        }
      })
      this.toggleLoading()
    }
  }
}
</script>
